
export const SocialMediaLinks = [
  { name: 'LinkedIn', url: 'https://linkedin.com/company/triggered-app', icon: 'linked-in-1' },
  { name: 'Facebook', url: 'https://facebook.com/TriggeredApp', icon: 'facebook-1' },
  { name: 'Instagram', url: 'https://instagram.com/triggered_app', icon: 'instagram-1' },
];
